<script setup lang="ts">
import Header from '~/components/blocks/two-six/header.vue';
import Footer from '~/components/blocks/two-six/footer.vue';

const props = defineProps<{
    page: {
        id: string;
        model: string;
        data: {
            title?: string;
            hideHeaderFooter?: boolean;
            [key: string]: any;
        };
        [key: string]: any;
    };
}>();

// Surface the chrome setting to the LAYOUT, which owns the intro animation and
// renders above this component with no access to Builder page data (Shannon,
// Asana 1217652819820640). A page that hides its header and footer is a bare
// embed, and the full-screen intro does not belong over one.
//
// watchEffect rather than a one-off assignment so a client-side navigation
// between a chromeless page and an ordinary one keeps the flag honest.
const chromeHidden = useState('page-chrome-hidden', () => false);
watchEffect(() => { chromeHidden.value = !!props.page?.data?.hideHeaderFooter; });
</script>

<template>
    <div class="page-wrapper flex min-h-dvh flex-col"
        :class="{ 'hide-header-footer': page.data?.hideHeaderFooter }"
        :data-model="page.model"
        :key="page.id">
        <Header v-if="!page.data?.hideHeaderFooter" />
        <div class="root-container flex-1">
            <main id="main" key="page" class="mess-page" tabindex="-1">
                <slot />
            </main>
        </div>
        <slot name="footer" />
        <Footer v-if="!page.data?.hideHeaderFooter" />
    </div>
</template>

<style>
/* [state] html.locked prevents scroll when mobile menu is open */
html.locked {
    overflow: hidden;
}

/* [state] hide-header-footer variant reduces header spacing */
.page-wrapper.hide-header-footer {
    --header-height: 1rem;
}
</style>
